function runSlick() {

	console.log('run')

	document.querySelectorAll('.carousel-block .slides').slick({
		dots: false,
		infinite: true,
		speed: 1000,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		arrows: true
	})
}
runSlick();
